import {ChangeDetectorRef,ViewRef, Component, Input, OnInit,EventEmitter,Output, OnChanges, SimpleChanges } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

import { InstructionListing } from '../../../../partials/content/listing/instruction-listing/instruction-listing.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

import { DialogService,VisiteService, StateService} from '../../../../../services'

const KEY = 'dossier-rdv-instructions'

@Component({
  selector: 'atyl-dossier-rdv-instructions',
  templateUrl: './dossier-rdv-instructions.component.html',
  styleUrls: ['./dossier-rdv-instructions.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-rdv-instructions',
  key: KEY,
})
export class DossierRdvInstructionsComponent implements OnInit, OnChanges {

  expanded: boolean = true;
  @Input() visite;
  @Input() instructions: any[] = [];
  @Input() tiers: any;
  @Input() user: any;

  @StringableValues(KEY) strings: any
 
 @Output() selectInstruction: EventEmitter<any> = new EventEmitter(null);
 
  selectedIns: any;  
 
  constructor(private dialogService: DialogService,
     private visiteService: VisiteService,
     private changeDetector: ChangeDetectorRef,
     private stateService: StateService
  ) { 
	  
	  
  }
  
    ngOnInit() {
        console.log("dossier-rdv-instructions",this.instructions);
        this.stateService.user.subscribe((user) => {
            if (user) {
                this.user = user;
                console.log("user dossier",this.user);
                this.setObjectUserRights(this.instructions, 'instruction');
            }

            })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.instructions && !changes.instructions.firstChange) {
            this.setObjectUserRights(this.instructions, 'instruction');
        }
    }
  
    viewInstruction(instruction:any) {
        console.log("VIEW_INSTR",instruction)
		this.selectedIns=instruction;
        this.selectInstruction.emit(instruction);
                                    
    }
  
  openInstruction(instruction:any) {
        this.dialogService.open(InstructionListing, {
            data: {
               
                dossier: this.tiers,
                visite: instruction,
                instructionRights: instruction.rights
            },
            draggable: false,
            resizable: false,
        }, (result) => {
            if (result) {
                console.log("ressh ID");
                this.visiteService.get(this.visite.ID).subscribe((res: JSONRpcResponse) => {
                             if (res.result && res.result.instructions!=undefined && res.result.instructions) {
                                 this.instructions=res.result.instructions;
                                 if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
                                        this.changeDetector.detectChanges()
                                  }
                                
                               }
                            }
                        )
           }}
           
          );             
      
  }
  
  addInstruction($event) {
	  
	  this.dialogService.open(InstructionListing, {
            data: {
               
                dossier: this.tiers,
                visite_add: this.visite
            },
            draggable: false,
            resizable: false,
        }, (result) => {
            if (result) {
                console.log("ressh ID");
                this.visiteService.get(this.visite.ID).subscribe((res: JSONRpcResponse) => {
                    if (res.result && res.result.instructions!=undefined && res.result.instructions) {
                        this.instructions=res.result.instructions;
                        if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
                            this.changeDetector.detectChanges()
                        }
                    }
                })
           }});
  }

  setObjectUserRights(obj: any | any[], type: string) {
    if (Array.isArray(obj)) {
        obj.forEach((item: any) => {
            item = this.applyRightsObj(item, type);
        });
    } else {
        obj = this.applyRightsObj(obj, type);
    }
    return obj;
}

applyRightsObj(obj: any, type: string) {
    let rg: any = {
        r: true,
        w: true,
        x: true
    };
    let key = null;
    
    switch (type) {
        case "instruction":
            key = obj.instruction.type.key;
            break;
    }

    if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
        if (this.user.droitsObjets[type][key] != undefined) {
            rg = this.user.droitsObjets[type][key];
        }
    }

    if(this.visite && this.visite.rights){
        let newRights = {};
        for(let right of ["r","w","x"]){
            newRights[right] = rg[right]? this.visite.rights[right]: false
        }
        rg = newRights;
    }

    obj.rights = rg;

    if (obj.editable) {
        obj.editable = rg.w;
    }
    return obj;
}
  
}
